import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';

/**
 * Outline button that copies `value` and confirms in place. Disabled when there's nothing to copy.
 * Pass a thunk when the text is expensive to build — it only runs on click.
 */
export const CopyButton: React.FC<{
  value: string | undefined | (() => string);
  label?: string;
  size?: 'xs' | 'sm';
  className?: string;
}> = ({ value, label = 'Copy', size = 'xs', className }) => {
  const { copied, copy } = useCopyToClipboard();

  return (
    <Button
      variant="outline"
      size={size}
      className={className}
      disabled={!value}
      onClick={() => copy(typeof value === 'function' ? value() : value)}
      icon={copied ? Check : Copy}
    >
      {copied ? 'Copied' : label}
    </Button>
  );
};
